<h2 class="margin-bottom-32">This tax should be applied to which properties?</h2>

<div fxFlexFill>
  <sbnb-property-selection
    fxFlex
    [selectedProperties]="tax.properties"
    [allProperties]="false"
    [border]="true"
    [allPropertiesEnabled]="false"
    [selectedProperties]="tax?.properties || []"
    [listHeight]="280"
    (propertiesChange)="propertiesUpdated($event)"></sbnb-property-selection>
</div>

<div style="margin-top: 32px" fxLayout fxLayoutGap="24px" fxLayoutAlign="end center">
  <sbnb-button
    data-intercom-target="direct-tax-scope-back"
    label="Back"
    type="secondary"
    (click)="back()"></sbnb-button>

  <sbnb-button data-intercom-target="direct-com-tax-scope-next" label="Continue" (click)="progress()"></sbnb-button>
</div>
